import angular from 'angular';
import {
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  actionIcon
} from 'app/components/global';
import DemoController from './demo.controller';
import demoDirective from './demo.directive';
import demoListItem from '../demo-list-item';
import editDemoSettingsDialog from '../dialog.settingsDialog';
import editDemoDialog from '../dialog.editDemoDialog';

export const routeConfig = {
  template: require('./demo.html'),
  controller: 'DemoController',
  controllerAs: 'demoVM',
};

export default angular.module('app.components.demo.demo', [
  actionIcon,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  demoListItem,
  editDemoSettingsDialog,
  editDemoDialog,
])
  .directive('demo', demoDirective)
  .controller('DemoController', DemoController)
  .name;

console.log('app.components.demo.demo created');
